export default "dist/images/components-columns-width-control-4-2-uneven.ec44d79.png";